import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNoticesPage = () => {
  return (
    <>
      <Helmet>
        <title>Mentions légales - Anti-Recouvrement.com</title>
        <meta name="description" content="Mentions légales du site Anti-Recouvrement.com" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-4">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Link to="/" className="inline-flex items-center text-blue-900 hover:text-blue-700">
              <ArrowLeft size={20} className="mr-2" />
              Retour à l'accueil
            </Link>
          </div>
        </header>

        {/* Content */}
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold mb-8" style={{ color: '#1e3a8a' }}>
            Mentions légales
          </h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
            {/* Éditeur */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">1. Éditeur du site</h2>
              <div className="text-gray-700 space-y-2">
                <p>Le site <strong>anti-recouvrement.com</strong> est édité par :</p>
                <ul className="list-none space-y-1 mt-4">
                  <li><strong>Raison sociale :</strong> Sequana</li>
                  <li><strong>Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</li>
                  <li><strong>Capital social :</strong> 10 €</li>
                  <li><strong>Siège social :</strong> 4 rue du Général Roux, 77590 Fontaine-le-Port, France</li>
                  <li><strong>SIRET :</strong> 978 347 540 00020</li>
                  <li><strong>RCS :</strong> 978 347 540 R.C.S. Melun</li>
                  <li><strong>TVA intracommunautaire :</strong> FR45978347540</li>
                  <li><strong>Président :</strong> Mathieu Welsch</li>
                  <li><strong>Email :</strong> hello@sequana.tech</li>
                </ul>
              </div>
            </section>

            {/* Directeur de publication */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">2. Directeur de la publication</h2>
              <p className="text-gray-700">
                Le directeur de la publication est <strong>Mathieu Welsch</strong>, en qualité de Président de la société Sequana.
              </p>
            </section>

            {/* Hébergeur */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">3. Hébergement</h2>
              <div className="text-gray-700 space-y-2">
                <p>Le site est hébergé par :</p>
                <ul className="list-none space-y-1 mt-4">
                  <li><strong>Raison sociale :</strong> OVH SAS</li>
                  <li><strong>Siège social :</strong> 2 rue Kellermann, 59100 Roubaix, France</li>
                  <li><strong>Téléphone :</strong> 1007 (depuis la France)</li>
                  <li><strong>Site web :</strong> www.ovhcloud.com</li>
                </ul>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">4. Propriété intellectuelle</h2>
              <p className="text-gray-700">
                L'ensemble des contenus présents sur le site anti-recouvrement.com (textes, images, graphismes, logo, icônes, etc.)
                est protégé par les dispositions du Code de la propriété intellectuelle et appartient à la société Sequana ou fait
                l'objet d'une autorisation d'utilisation.
              </p>
              <p className="text-gray-700 mt-4">
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site,
                quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Sequana.
              </p>
            </section>

            {/* Nature du service */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">5. Nature du service</h2>
              <p className="text-gray-700">
                Anti-recouvrement.com est un service d'information juridique automatisé. Il fournit une analyse préliminaire
                de documents de recouvrement à titre informatif uniquement.
              </p>
              <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <p className="text-amber-800 text-sm">
                  <strong>Important :</strong> Ce service ne constitue pas un conseil juridique et ne se substitue pas à la
                  consultation d'un avocat ou d'un professionnel du droit. Les analyses fournies sont des indications générales
                  qui ne préjugent en rien de la décision d'un tribunal.
                </p>
              </div>
            </section>

            {/* Limitation de responsabilité */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">6. Limitation de responsabilité</h2>
              <p className="text-gray-700">
                Sequana s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site.
                Toutefois, Sequana ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations
                mises à disposition sur ce site.
              </p>
              <p className="text-gray-700 mt-4">
                En conséquence, Sequana décline toute responsabilité :
              </p>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site ;</li>
                <li>pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations ;</li>
                <li>pour tout préjudice direct ou indirect résultant de l'utilisation des informations fournies par le site.</li>
              </ul>
            </section>

            {/* Données personnelles */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">7. Données personnelles</h2>
              <p className="text-gray-700">
                Pour connaître notre politique en matière de protection des données personnelles, veuillez consulter notre{' '}
                <Link to="/confidentialite" className="text-blue-600 hover:underline">
                  Politique de confidentialité
                </Link>.
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">8. Cookies</h2>
              <p className="text-gray-700">
                Le site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visite.
                Pour plus d'informations sur l'utilisation des cookies, consultez notre{' '}
                <Link to="/confidentialite" className="text-blue-600 hover:underline">
                  Politique de confidentialité
                </Link>.
              </p>
            </section>

            {/* Droit applicable */}
            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-900">9. Droit applicable</h2>
              <p className="text-gray-700">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français
                seront seuls compétents.
              </p>
            </section>

            {/* Date de mise à jour */}
            <section className="pt-4 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-6 mt-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-center text-gray-500 text-sm">
              © {new Date().getFullYear()} Anti-Recouvrement.com — Sequana SASU
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LegalNoticesPage;
